<template>
	<span
		class="pronto-tag"
		:class="{ large, primary, danger, outline, solid, uppercase, rounded }"
		><slot
	/></span>
</template>

<script>
export const sizes = {
	LARGE: 'large',
}
export const variants = {
	OUTLINE: 'outline',
	SOLID: 'solid',
}
export const colors = {
	PRIMARY: 'primary',
	DANGER: 'danger',
}

export default {
	name: 'Tag',
	props: {
		// colors props are just boolean flags
		...Object.values(colors).reduce(
			(acc, t) => ({ ...acc, [t]: { type: Boolean, default: null } }),
			{}
		),
		// size props are just boolean flags
		...Object.values(sizes).reduce(
			(acc, s) => ({ ...acc, [s]: { type: Boolean, default: null } }),
			{}
		),
		// variant props are just boolean flags
		...Object.values(variants).reduce(
			(acc, s) => ({ ...acc, [s]: { type: Boolean, default: null } }),
			{}
		),
		uppercase: { type: Boolean, default: true },
		rounded: { type: Boolean, default: false },
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.pronto-tag {
	padding: 2px 2px 1px 2px;
	border-radius: 3px;
	font-size: 9px;
	color: var(--neutral-800);
	border: 1px solid var(--neutral-800);
	flex-shrink: 0;
	&.uppercase {
		text-transform: uppercase;
	}
	&.large {
		font-size: 12px;
		padding: 4px 8px 3px 8px;
	}
	&.primary {
		color: var(--blue-300);
		border-color: var(--blue-300);
	}
	&.danger {
		color: var(--red-200);
		border-color: var(--red-200);
	}
	&.solid {
		border-color: var(--neutral-600);
		background-color: var(--neutral-600);
		color: var(--neutral-0);
		&.primary {
			background: var(--blue-300);
			color: var(--neutral-0);
		}
		&.danger {
			background: var(--red-200);
			color: var(--neutral-0);
		}
	}
	&.rounded {
		@include radius;
	}
}
</style>
